<template>
  <div style="height:100%">
    <div class="flex-between">
      <p class="topic">历史环境</p>
      <a v-if="!showList" @click="backToList" class="mgr-48 mgt-24">返回历史环境列表</a>
    </div>
    <custom-table
      class="mgtb-24 mglr-24"
      v-if="showList"
      :oriConfig="tableConfig"
      :columns="columns"
      :tableLoading="tableLoading"
      @reset="resetFlag = !resetFlag"
      @sorter="(...param) => handleSorterUpdate(...param, columns)"
      ref="custom_table"
    >
      <template slot="tableHeaderRender">
        <a-button type="danger" @click="handleBatchDelete()">删除</a-button>
      </template>
      <template slot="modeFilter">
        <custom-table-filter
          ref="mode_filter"
          :resetFlag="resetFlag"
          :options="modeArray"
          @update="(val) => handleFilterUpdate(val, 'archiveMode', columns)"
          @filter="(val) => $refs.custom_table.handleFilter(val, 'filter.archiveMode')"
        ></custom-table-filter>
      </template>
      <template slot="archiveMode" slot-scope="{ record }">
        <span>{{ record.archiveMode == 0 ? '自动' : '手动' }}</span>
      </template>
      <span slot="action" slot-scope="{ record }">
        <a @click="handleDetail(record.uid)">查看</a>
        <a @click="handleDelete(record.uid)" v-if="!record.inUse" class="mgl-8">删除</a>
      </span>
      <span style="text-overflow: ellipsis" slot="archiveDescription" slot-scope="{ record }">{{
        record.archiveDescription ? record.archiveDescription : '-'
      }}</span>
      <span style="text-overflow: ellipsis" slot="createTime" slot-scope="{ record }">{{
        record.createTime ? timestamp2Date(record.createTime) : '-'
      }}</span>
      <span style="text-overflow: ellipsis" slot="lastActiveTime" slot-scope="{ record }">{{
        record.lastActiveTime ? timestamp2Date(record.lastActiveTime) : '-'
      }}</span>
    </custom-table>
    <sql-list :sessionId="sessionId" v-else></sql-list>
  </div>
</template>
<script>
import { sessionsApi, delSessionSqlsApi } from '@/api/sessions'
import CustomTable from '@/components/Custom/CustomTable.vue'
import CustomTableFilter from '@/components/Custom/CustomTableFilter.vue'
import SqlList from './components/SqlList.vue'
import { timestamp2Date } from '@/utils/util'
export default {
  name: 'History',
  components: { CustomTable, CustomTableFilter, SqlList },
  computed: {
    tableConfig() {
      return {
        searchPlaceholder: '请输入归档描述进行搜索',
        searchParam: 'search.archiveDescription',
        loadData: sessionsApi,
        pagination: {
          pageNo: 1,
          pageSize: 10,
          total: 0,
        },
        rowKey: 'uid',
        selectedAble: true,
        loadParam: { inUse: false },
      }
    },
  },
  data() {
    return {
      modeArray: [
        { label: '手动', value: 1 },
        { label: '自动', value: 0 },
      ],
      resetFlag: false,
      showList: true,
      tableLoading: false,
      sessionId: '',
      columns: [
        {
          title: '归档方式',
          dataIndex: 'archiveMode',
          width: 100,
          onFilterDropdownVisibleChange: (val) => {
            if (!val) this.$refs.mode_filter.handleHide(val)
          },
          scopedSlots: { customRender: 'archiveMode', filterDropdown: 'modeFilter' },
        },
        {
          title: '归档描述',
          dataIndex: 'archiveDescription',
          width: 200,
          scopedSlots: { customRender: 'archiveDescription' },
        },
        {
          title: '运行语句',
          dataIndex: 'statementCount',
          width: 100,
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 160,
          scopedSlots: { customRender: 'createTime' },
          sorter: true,
          sortOrder: false
        },
        {
          title: '最后活动时间',
          dataIndex: 'lastActiveTime',
          width: 160,
          scopedSlots: { customRender: 'lastActiveTime' },
          sorter: true,
          sortOrder: false
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 120,
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {
    timestamp2Date,
    backToList() {
      this.showList = true
    },
    handleDetail(uid) {
      this.showList = false
      this.sessionId = uid
    },
    handleFilterUpdate(val, dataIndex, columns) {
      columns.find((item) => item.dataIndex === dataIndex).filtered = val.length > 0
      columns = [...columns]
    },
    handleSorterUpdate (val, dataIndex, columns) {
      columns.map(item => {
        if (item.dataIndex !== dataIndex && item.sortOrder) {
          item.sortOrder = false
        } else if (item.dataIndex === dataIndex) {
          item.sortOrder = val
        }
        return item
      })
      columns = [...columns]
    },
    handleDelete(id) {
      const _this = this
      this.$confirm({
        title: '提示',
        content: '确定删除此归档？',
        okText: '确定',
        cancelText: '取消',
        centered: true,
        maskClosable: true,
        okType: 'danger',
        onOk() {
          delSessionSqlsApi({ sessionIds: [id] })
            .then((res) => {
              _this.$message.success('删除归档成功')
              _this.$refs.custom_table.handleRestart()
            })
            .catch((res) => {
              _this.$message.error('删除归档失败：' + res.response.data.msg + '请稍后重试...')
            })
        },
      })
    },
    handleBatchDelete(ids) {
      if (!ids) {
        ids = this.$refs.custom_table.selectedRowKeys
      }
      if (!ids.length) {
        this.$message.error('请选择要删除的归档')
        return
      }
      const _this = this
      this.$confirm({
        title: '提示',
        content: '确定删除归档？',
        okText: '确定',
        cancelText: '取消',
        centered: true,
        maskClosable: true,
        okType: 'danger',
        onOk() {
          delSessionSqlsApi({ sessionIds: ids })
            .then((res) => {
              _this.$message.success('删除归档成功')
              _this.$refs.custom_table.handleRestart()
            })
            .catch((res) => {
              _this.$message.error('删除归档失败：' + res.response.data.msg + '请稍后重试...')
            })
        },
      })
    },
  },
}
</script>
<style lang="less" scoped>
</style>